import {Checkbox, CircularProgress, Divider, FormControlLabel, Grid, Typography, TextField} from '@material-ui/core';
import {Alert} from '@material-ui/lab';
import {changeFormNumberError} from 'ApplicationEntry/ducks/billingAgent';
import {
  changeAnswer,
  changeAnswerforAllQuestions,
  changeAnswersforAllQuestionsNoCheckBox,
  changeHeight,
  changeWeight,
  getQuestionList,
  removeQuestions,
  UnassignQuestions,
} from 'ApplicationEntry/ducks/underwritingQuestions';
import {ApplicationType} from 'ApplicationEntry/models/ApplicationType';
import {FormNumber, isFormNumberError, isLoaded as isLoadedFormNumber} from 'ApplicationEntry/models/FormNumber';
import {isValidHeight} from 'ApplicationEntry/models/Height';
import {UWQuestions} from 'ApplicationEntry/models/UnderwritingQuestions';
import {isUnassignedUWQuestions, isUWQuestionsError, matchUWQuestions} from 'ApplicationEntry/models/UWQuestionsModel';
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import * as ErrorMessages from 'ApplicationEntry/components/WorkFlow/ErrorMessages';
import './Underwriting.sass';

import useLongPress from './ProductsRiders/Group/useLongPress';

type UWQuestionsProps = {
  uwQuestions: UWQuestions;
  formNumber: FormNumber;
  applicationType?: string;
};

const UnderwritingQuestionsSection = (props: UWQuestionsProps) => {
  const {formNumber, applicationType} = props;
  const {
    questionList,
    answers,
    height,
    spouseHeight,
    childHeight,
    weight,
    spouseWeight,
    childWeight,
  } = props.uwQuestions;

  const dispatch = useDispatch();
  const [localFormNumber, setFormNumber] = useState(formNumber);
  const {action, handlers, isLongPress} = useLongPress();
  const {action: otherAction, handlers: otherHandlers} = useLongPress();

  useEffect(() => {
    if (
      isLoadedFormNumber(formNumber) &&
      (isUnassignedUWQuestions(questionList) || isUWQuestionsError(questionList) || localFormNumber !== formNumber)
    ) {
      dispatch(getQuestionList(formNumber.Data.value));
      setFormNumber(formNumber);
    } else if (isFormNumberError(formNumber) && formNumber.value !== '') {
      if (formNumber.value === '') {
        dispatch(UnassignQuestions());
      } else {
        dispatch(removeQuestions());
      }
      dispatch(changeFormNumberError(''));
    }
  }, [formNumber, dispatch, questionList, localFormNumber]);

  const getDuplicates = (test: string[]) => {
    const duplicates = {};
    for (let i = 0; i < test.length; i++) {
      if (duplicates.hasOwnProperty(test[i])) {
        duplicates[test[i]].push(i);
      } else if (test.lastIndexOf(test[i]) !== i) {
        duplicates[test[i]] = [i];
      }
    }

    return duplicates;
  };

  const getQuestionNumberList = (indexArr: string[]) => {
    const a = 97;
    const eligibilityQuestions = indexArr.filter(q => parseInt(q, 10) >= 400);
    const underWritingOrder = indexArr.filter(q => parseInt(q, 10) < 400);
    const duplicates = getDuplicates(underWritingOrder);
    const keys = Object.keys(duplicates);

    keys.forEach(key => {
      const indexes = duplicates[key];

      indexes.forEach((i: React.Key, index: number) => {
        underWritingOrder[i] = underWritingOrder[i] + String.fromCharCode(a + index);
      });
    });
    const updatedUnderwriting = underWritingOrder.map(uw => uw + '. ');
    const eligibleQuestions = eligibilityQuestions.map(uw => uw + '. ');
    return updatedUnderwriting.concat(eligibleQuestions);
  };

  const getHeader = (title: string) => {
    return (
      <div className="uwQuestions-section__title-container">
        <Typography variant="subtitle1" className="uwQuestions-section__title-container-title">
          {title}
        </Typography>
      </div>
    );
  };

  return (
    <>
      <form noValidate autoComplete="off" className="uwQuestions-section">
        {getHeader('Underwriting Questions')}

        <div>
          {matchUWQuestions({
            Loading: () => <CircularProgress className="uwQuestions-section__loading-icon" />,
            Loaded: uw => {
              const uwArray = [] as string[];
              uw.forEach(order => uwArray.push(order.questionOrder));
              const questionNumberList = getQuestionNumberList(uwArray);
              return (
                <>
                  {/* <div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={() =>
                            uw.map((question, idx) => {
                              dispatch(changeAnswer(true, idx));
                            })
                          }
                        />
                      }
                      label="Master Yes"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={() =>
                            uw.map((question, idx) => {
                              dispatch(changeAnswer(false, idx));
                            })
                          }
                        />
                      }
                      label="Master No"
                    />
                  </div> */}
                  <Grid container spacing={4}>
                    {uw.map((question, index) => (
                      <>
                        <Grid item xs={6} key={`uw-question-${index + 1}-question`}>
                          <span> {question.questionName + '.' + ' ' + question.description} : </span>
                        </Grid>
                        <Grid item xs={6} key={`uw-question-${index + 1}-label`}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={answers.get(index) ? true : false}
                                onChange={event => {
                                  if (isLongPress.current === true) {
                                    uw.map((question, idx) => {
                                      dispatch(changeAnswerforAllQuestions(event.target.checked, idx));
                                    });
                                  } else {
                                    dispatch(changeAnswer(true, index));
                                  }
                                }}
                                onKeyPress={event => {
                                  handlers.onkeypress();

                                  if (
                                    event.key === 'y' ||
                                    event.key === 'Y' ||
                                    event.key === 'Spacebar' ||
                                    event.key === 'Enter'
                                  ) {
                                    if (isLongPress.current === true) {
                                      uw.map((question, idx) => {
                                        dispatch(changeAnswer(true, idx));
                                      });
                                    } else {
                                      dispatch(changeAnswer(true, index));
                                    }
                                  }
                                }}
                                {...handlers}
                                name="checkedB"
                                color="secondary"
                              />
                            }
                            label="Yes"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={answers.get(index) === false ? true : false}
                                onChange={event => {
                                  if (isLongPress.current === true) {
                                    uw.map((question, idx) => {
                                      dispatch(changeAnswersforAllQuestionsNoCheckBox(event.target.checked, idx));
                                    });
                                  } else {
                                    dispatch(changeAnswer(false, index));
                                  }
                                }}
                                onKeyPress={event => {
                                  handlers.onkeypress();

                                  if (
                                    event.key === 'n' ||
                                    event.key === 'N' ||
                                    event.key === 'Spacebar' ||
                                    event.key === 'Enter'
                                  ) {
                                    if (isLongPress.current === true) {
                                      uw.map((question, idx) => {
                                        dispatch(changeAnswer(false, idx));
                                      });
                                    } else {
                                      dispatch(changeAnswer(false, index));
                                    }
                                  }
                                }}
                                name="checkedB"
                                color="secondary"
                                {...handlers}
                              />
                            }
                            label="No"
                          />
                        </Grid>
                        <>
                          {applicationType === ApplicationType.Group &&
                          question.description.toUpperCase() === 'HEIGHTWEIGHT' ? (
                            <Grid item xs={8}>
                              <div className="uwQuestions-section__HeightWeightFields_Container">
                                <div className="uwQuestions-section__HeightWeightFields_Employee_Container">
                                  <span className="uwQuestions-section__HeightWeightFields_Header">Employee</span>
                                  <div className="uwQuestions-section__HeightWeightFields">
                                    <Grid item xs={12} md={3}>
                                      <TextField
                                        InputProps={{inputProps: {min: 0, max: 8}}}
                                        className="uwQuestions-section__field"
                                        helperText={
                                          height === undefined
                                            ? true
                                            : isValidHeight(height!)
                                            ? ''
                                            : ErrorMessages.INVALID_HEIGHT
                                        }
                                        error={height === undefined ? false : !isValidHeight(height!)}
                                        id="height-feet"
                                        label="Height (Feet)"
                                        name="EmployeeHeight"
                                        onChange={e => {
                                          const heightFts = Number(e.target.value);

                                          dispatch(
                                            changeHeight(
                                              heightFts === Number.NaN ? '' : heightFts,
                                              height?.inches!,
                                              e.target.name
                                            )
                                          );
                                        }}
                                        placeholder="Feet"
                                        value={height?.feet === Number.NaN ? '' : height?.feet}
                                        type="number"
                                        variant="outlined"
                                      />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                      <TextField
                                        InputProps={{inputProps: {min: 0, max: 11}}}
                                        className="uwQuestions-section__field"
                                        id="height-inches"
                                        label="Height (Inches)"
                                        name="EmployeeHeight"
                                        onChange={e => {
                                          const heightIchs = Number(e.target.value);
                                          dispatch(
                                            changeHeight(
                                              height?.feet!,
                                              heightIchs === Number.NaN ? '' : heightIchs,
                                              e.target.name
                                            )
                                          );
                                        }}
                                        helperText={
                                          height === undefined
                                            ? true
                                            : isValidHeight(height!)
                                            ? ''
                                            : ErrorMessages.INVALID_HEIGHT
                                        }
                                        error={height === undefined ? false : !isValidHeight(height!)}
                                        placeholder="Inches"
                                        type="number"
                                        value={height?.inches === Number.NaN ? '' : height?.inches}
                                        variant="outlined"
                                      />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                      <TextField
                                        inputProps={{
                                          maxLength: 3,
                                        }}
                                        id="weight"
                                        label="Weight"
                                        className="uwQuestions-section__field"
                                        name="EmployeeWeight"
                                        onChange={e => dispatch(changeWeight(e.target.value, e.target.name))}
                                        placeholder="Weight (lbs)"
                                        variant="outlined"
                                        value={weight}
                                      />
                                    </Grid>
                                  </div>
                                </div>
                                <div className="uwQuestions-section__HeightWeightFields_Spouse_Container">
                                  <span className="uwQuestions-section__HeightWeightFields_Header">Spouse</span>
                                  <div className="uwQuestions-section__HeightWeightFields">
                                    <Grid item xs={12} md={3}>
                                      <TextField
                                        InputProps={{inputProps: {min: 0, max: 8}}}
                                        className="uwQuestions-section__field"
                                        helperText={
                                          spouseHeight === undefined
                                            ? true
                                            : isValidHeight(spouseHeight!)
                                            ? ''
                                            : ErrorMessages.INVALID_HEIGHT
                                        }
                                        error={spouseHeight === undefined ? false : !isValidHeight(spouseHeight!)}
                                        id="height-feet"
                                        label="Height (Feet)"
                                        name="SpouseHeight"
                                        onChange={e => {
                                          const spouseheight = Number(e.target.value);
                                          dispatch(
                                            changeHeight(
                                              spouseheight === Number.NaN ? '' : spouseheight,
                                              spouseHeight?.inches!,
                                              e.target.name
                                            )
                                          );
                                        }}
                                        placeholder="Feet"
                                        value={spouseHeight?.feet === Number.NaN ? '' : spouseHeight?.feet}
                                        type="number"
                                        variant="outlined"
                                      />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                      <TextField
                                        InputProps={{inputProps: {min: 0, max: 11}}}
                                        className="uwQuestions-section__field"
                                        id="height-inches"
                                        label="Height (Inches)"
                                        name="SpouseHeight"
                                        onChange={e => {
                                          const spouseHeightIchs = Number(e.target.value);
                                          dispatch(
                                            changeHeight(
                                              spouseHeight?.feet!,
                                              spouseHeightIchs === Number.NaN ? '' : spouseHeightIchs,
                                              e.target.name
                                            )
                                          );
                                        }}
                                        helperText={
                                          spouseHeight === undefined
                                            ? true
                                            : isValidHeight(spouseHeight!)
                                            ? ''
                                            : ErrorMessages.INVALID_HEIGHT
                                        }
                                        error={spouseHeight === undefined ? false : !isValidHeight(spouseHeight!)}
                                        placeholder="Inches"
                                        type="number"
                                        value={spouseHeight?.inches === Number.NaN ? '' : spouseHeight?.inches}
                                        variant="outlined"
                                      />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                      <TextField
                                        className="uwQuestions-section__field"
                                        id="weight"
                                        label="Weight"
                                        name="SpouseWeight"
                                        onChange={e => dispatch(changeWeight(e.target.value, e.target.name))}
                                        placeholder="Weight (lbs)"
                                        variant="outlined"
                                        value={spouseWeight}
                                        inputProps={{
                                          maxLength: 3,
                                        }}
                                      />
                                    </Grid>
                                  </div>
                                </div>
                                <div className="uwQuestions-section__HeightWeightFields_Child_Container">
                                  <span className="uwQuestions-section__HeightWeightFields_Header">Child</span>
                                  <div className="uwQuestions-section__HeightWeightFields">
                                    <Grid item xs={12} md={3}>
                                      <TextField
                                        InputProps={{inputProps: {min: 0, max: 8}}}
                                        className="uwQuestions-section__field"
                                        helperText={
                                          childHeight === undefined
                                            ? true
                                            : isValidHeight(childHeight!)
                                            ? ''
                                            : ErrorMessages.INVALID_HEIGHT
                                        }
                                        error={childHeight === undefined ? false : !isValidHeight(childHeight!)}
                                        id="height-feet"
                                        label="Height (Feet)"
                                        name="ChildHeight"
                                        onChange={e => {
                                          const childheightFt = Number(e.target.value);
                                          dispatch(
                                            changeHeight(
                                              childheightFt === Number.NaN ? '' : childheightFt,
                                              childHeight?.inches!,
                                              e.target.name
                                            )
                                          );
                                        }}
                                        placeholder="Feet"
                                        value={childHeight?.feet === Number.NaN ? '' : childHeight?.feet}
                                        type="number"
                                        variant="outlined"
                                      />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                      <TextField
                                        InputProps={{inputProps: {min: 0, max: 11}}}
                                        className="uwQuestions-section__field"
                                        id="height-inches"
                                        label="Height (Inches)"
                                        name="ChildHeight"
                                        onChange={e => {
                                          const childheightIchs = Number(e.target.value);
                                          dispatch(
                                            changeHeight(
                                              childHeight?.feet!,
                                              childheightIchs === Number.NaN ? '' : childheightIchs,
                                              e.target.name
                                            )
                                          );
                                        }}
                                        helperText={
                                          childHeight === undefined
                                            ? true
                                            : isValidHeight(childHeight!)
                                            ? ''
                                            : ErrorMessages.INVALID_HEIGHT
                                        }
                                        error={childHeight === undefined ? false : !isValidHeight(childHeight!)}
                                        placeholder="Inches"
                                        type="number"
                                        value={childHeight?.inches === Number.NaN ? '' : childHeight?.inches}
                                        variant="outlined"
                                      />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                      <TextField
                                        className="uwQuestions-section__field"
                                        id="weight"
                                        label="Weight"
                                        name="ChildWeight"
                                        onChange={e => dispatch(changeWeight(e.target.value, e.target.name))}
                                        placeholder="Weight (lbs)"
                                        variant="outlined"
                                        value={childWeight}
                                        inputProps={{
                                          maxLength: 3,
                                        }}
                                      />
                                    </Grid>
                                  </div>
                                </div>
                              </div>
                            </Grid>
                          ) : (
                            ''
                          )}
                        </>
                      </>
                    ))}
                  </Grid>
                </>
              );
            },
            Unassigned: () => (
              <Alert severity="info">
                Provide form number details in Billing & Agent section to view Underwriting questions.
              </Alert>
            ),
            Error: () => (
              <Alert severity="error">
                No Underwriting Questions for form {localFormNumber.key === 'Loaded' ? localFormNumber.Data.value : ''}
              </Alert>
            ),
            UWQuestionsError: () => (
              <Alert severity="error">Please provide valid form number to view Underwriting questions.</Alert>
            ),
          })(questionList)}
        </div>
        <Divider className="application-form__actions-divider" />
      </form>
    </>
  );
};

export default UnderwritingQuestionsSection;
